import { render, staticRenderFns } from "./MessageRow.vue?vue&type=template&id=a581cce2&"
import script from "./MessageRow.vue?vue&type=script&lang=js&"
export * from "./MessageRow.vue?vue&type=script&lang=js&"
import style0 from "./MessageRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports